// Environment configuration utility
export const env = {
  // ArcGIS Configuration
  ARCGIS_API_KEY: import.meta.env.VITE_ARCGIS_API_KEY || '',
  DEFAULT_BASEMAP: import.meta.env.VITE_DEFAULT_BASEMAP || 'streets-vector',
  DEFAULT_CENTER_LNG: Number(import.meta.env.VITE_DEFAULT_CENTER_LNG) || 77.2090,
  DEFAULT_CENTER_LAT: Number(import.meta.env.VITE_DEFAULT_CENTER_LAT) || 28.6139,
  DEFAULT_ZOOM: Number(import.meta.env.VITE_DEFAULT_ZOOM) || 6,

  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',

  // AWS Configuration
  AWS_REGION: import.meta.env.VITE_AWS_REGION || 'eu-west-1',

  // Cognito Configuration
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  COGNITO_USER_POOL_CLIENT_ID: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '',

  // Amplitude Configuration
  AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY || '',

  // Environment
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || 'dev',
} as const;

export default env;
